import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import loadable from 'react-loadable';
import LoadingPlaceholder from '~/components/loading-placeholder/loading-placeholder';
import useLayoutContext from '~/contexts/layout';
function useAnalyticsPageView() {
    var _a;
    const location = useLocation();
    const isRedirect = (_a = location.state) === null || _a === void 0 ? void 0 : _a.redirect;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [isRedirect]);
}
function usePage(name) {
    return React.useMemo(() => {
        return loadable({
            loader: () => import(`~/pages/${name}/${name}`),
            loading: LoadingPlaceholder,
            render(loaded, props) {
                const Component = loaded.default;
                return React.createElement(Component, Object.assign({}, props));
            }
        });
    }, [name]);
}
export function ImportedPage({ name }) {
    const { pathname } = useLocation();
    const Page = usePage(name);
    const { layoutParameters, setLayoutParameters } = useLayoutContext();
    if (layoutParameters.name === null) {
        setLayoutParameters();
    }
    useAnalyticsPageView();
    // Scroll to the top when the pathname changes
    // (Avoids scrolling when going to a new tab)
    useEffect(() => window.scrollTo(0, 0), [name, pathname]);
    return React.createElement(Page, null);
}
